import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from '../utils/context';

// Tailwind badge; allow override via className
function Badge({ children, className = '' }) {
  const { theme } = useContext(ThemeContext);
  const base = 'text-[11px] font-medium inline-flex items-center gap-1 px-3 py-1 rounded-full border backdrop-blur-sm transition-colors';
  const mode = theme === 'light'
    ? 'bg-white/80 border-gray-200 hover:bg-white'
    : 'bg-neutral-800/70 border-neutral-700 hover:bg-neutral-800';
  return (
    <span className={`${base} ${mode} ${className}`}>{children}</span>
  );
}

Badge.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
};

export default Badge;
